import { render, staticRenderFns } from "./supplier-credit.vue?vue&type=template&id=a526a6b4&scoped=true"
import script from "./supplier-credit.vue?vue&type=script&lang=js"
export * from "./supplier-credit.vue?vue&type=script&lang=js"
import style0 from "./supplier-credit.vue?vue&type=style&index=0&id=a526a6b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a526a6b4",
  null
  
)

export default component.exports